import { z } from 'zod';

/** The organization's active overrides for one locale, and the org's version (bumped on every change). */
export const TextOverridesBundleSchema = z.object({
  orgId: z.string(),
  locale: z.string(),
  version: z.number().int().nonnegative(),
  messages: z.record(z.string(), z.string()),
});
export type TextOverridesBundle = z.infer<typeof TextOverridesBundleSchema>;

export const TextOverrideSaveBodySchema = z.object({
  locale: z.string(),
  value: z.string(),
  baseValue: z.string(),
});

/** Answer to a save (value = the text) and to a reset (value = null). */
export const TextOverrideWriteResponseSchema = z.object({
  orgId: z.string(),
  locale: z.string(),
  key: z.string(),
  value: z.string().nullable(),
  version: z.number().int().nonnegative(),
});

export const TextOverrideHistoryResponseSchema = z.object({
  orgId: z.string(),
  locale: z.string(),
  key: z.string(),
  revisions: z.array(
    z.object({
      id: z.number().int(),
      value: z.string().nullable(),
      baseValue: z.string().nullable(),
      createdAt: z.string(),
    }),
  ),
});

/** The org's change counter (`GET /orgs/:orgId/version`); polled for live updates. */
export const TextOverridesVersionSchema = z.object({ orgId: z.string(), version: z.number().int().nonnegative() });

export const TextOverridesErrorSchema = z.object({
  error: z.string(),
  details: z.unknown(),
});
